export const initialise = () => {
    if (!document.body.classList.contains('page-home')) return
    homeVideo()
}

const homeVideo = () => {
    const banner = document.querySelector<HTMLElement>('.page-home__hero .banner-pool-widget')
    if (!banner) return
    const video = banner.querySelector<HTMLIFrameElement>('iframe')
    if (!video) return

    // Fade in video once it loads
    video.addEventListener('load', () => {
        video.classList.add('loaded')
    })

    const src = video.src
    if (src) {
        const videoIdMatch: RegExpMatchArray | null = src.match(/(?:v=|youtu\.be\/|\/(?:embed|shorts|live)\/)([0-9A-Za-z_-]{11})(?:[?&#]|$)/)
        const videoId: string = videoIdMatch ? videoIdMatch[1] : ''
        if (videoId) {
            video.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&controls=0&disablekb=1&rel=0&playlist=${videoId}`
        }
    }
}